

























import { defineComponent, PropType } from '@vue/composition-api'
import { crudEditComposition } from '~/compositions/crudEditComposition'
import vRules from '~/utils/vRules'
import CreateDialog from './CreateDialog.vue'
export default defineComponent({
  components: { CreateDialog },
  props: {
    modelName: String,
    createEditFunction: {
      type: Function,
      required: true,
    },
    editedItem: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: false,
    },
    defaultCrud: {
      type: Object,
      required: true,
    },
    noValidate: Boolean,
    validateFunction: {
      type: Function as PropType<() => Promise<boolean>>,
      default: () => true,
    },
    rejectFunction: {
      type: Function as PropType<() => Promise<boolean>>,
      default: () => true,
    },
    acceptText: String,
    cancelText: String,
  },
  setup(props, ctx) {
    return {
      ...crudEditComposition(
        // @ts-ignore
        props,
        ctx,
        props.defaultCrud,
        props.createEditFunction,
        props.noValidate,
        props.validateFunction,
        props.rejectFunction,
      ),
      vRules,
    }
  },
  methods: {
    resetFormValidation() {
      this.form?.resetValidation()
    },
  },
})
